export function initFilePickers() {
    const pickers = document.querySelectorAll<HTMLLabelElement>('label[for].custom-file-picker');
    pickers.forEach(picker => {
        const input = picker.querySelector<HTMLInputElement>('input[type=file]');
        const current = picker.querySelector<HTMLElement>('.file-picker-current-file');

        if (input.files.length === 0) {
            current.innerText = 'Der er ikke valgt nogen fil';
        }

        input.addEventListener('change', e => {
            current.innerText = input.files.length === 0 ? 'Der er ikke valgt nogen fil' : input.files[0].name;
        });

        picker.addEventListener('keypress', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                picker.click();
            }
        });
    });
}